<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>A loving husband and father, a CA, and a financial leader in his sector. Sylvester Alex Bosch’s view on life is drawn from diverse cultural backgrounds. He is a strong believer in philosophy, mystery, fantasy, history and religion. He believes nothing just happens; that we all came from somewhere; are here for a reason and season, and when our time here is up, we continue to exist in a new dimension that includes fighting mysterious battles we barely knew existed during our life time. Success in these unknown battles that lie beyond the grave is predicated on diligence, shrewdness, perseverance, humility and excellence.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?938e8d46